export default __webpack_public_path__ + "static/media/nftb.bcc4d37c.svg";